import Headcom from "../../src/components/Headcom";
import FooterCom from "../../src/components/FooterCom";
import FooterDis from "../../src/Description/FooterDis";
import CookieCom from "../../src/components/CookieCom";
import GameCommonDis from "../../src/Description/GameCommonDis";
import { PageList } from "../../src/list/PageList";
import { Assets } from "../../src/list/Assets";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Link from "next/link";
import Snow_fx from "../../src/fx/Snow_fx";
import Image from "next/image";

export default function PrivacyPage() {
  const path = useRouter();

  useEffect(() => {
  }, []);
  return (
    <div>
      <Headcom
        title={PageList[4].title}
        s_dis={PageList[4].s_dis}
        path={PageList[4].path[1] + PageList[4].path[0]}
        thumb={PageList[4].thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
<div className="privacy-form">
        <div className="privacy-container">
          <Link href={"/"} className="privacy-logo" passHref>
            
                <Image decoding="async" alt="Logo" title="logo" src={Assets[0].logo2} fill 
                  className="unset_position"></Image>
            
            </Link>
            
            <h1>Our Partners</h1>
            <p className="p_center">We are always on the lookout for long-term partnership and collaboration. Below you can find some of our friends/partner website details where you can find the cute collection of our games.</p>
            <Link href={"https://cutedressup.com/"} target={"_blank"} className="partners-logo" passHref>
           
                <Image decoding="async" width={225} height={115} alt="Logo" title="logo" src={Assets[0].cutedressup} ></Image>
           
            </Link>
            <Link href={"https://www.dl-girls.com/"}target={"_blank"} className="partners-logo" passHref>
            
                <Image decoding="async" width={200} height={80} alt="Logo" title="logo" src={Assets[0].dl_girls} ></Image>
            
            </Link>
            <Link href={"https://www.play-games.com/dress-up-games.html"} target={"_blank"} className="partners-logo" passHref >
                <Image decoding="async" width={300} height={80} alt="Logo" title="logo" src={Assets[0].friv_games} ></Image>
           
            </Link>
            <Link href={"https://www.brightestgames.com/girls"}target={"_blank"} className="partners-logo" passHref >
            
                <Image decoding="async" width={228} height={97} alt="Logo" title="logo" src={Assets[0].brightest_games} ></Image>
            
            </Link>
            <Link href={"https://www.vitalitygames.com/girls-games"} target={"_blank"} className="partners-logo" passHref>
            
                <Image decoding="async" width={228} height={97} alt="Logo" title="logo" src={Assets[0].vitality_games} ></Image>
            
            </Link>
            <Link href={"https://www.dressupwho.com/"} target={"_blank"} className="partners-logo" passHref>
        
                <Image decoding="async" width={230} height={115} alt="Logo" title="logo" src={Assets[0].dressupwho} ></Image>
            
            </Link>
        </div>
        
    </div>
    <GameCommonDis />
    <FooterDis/>
    <FooterCom/>
    <CookieCom/>
    <Snow_fx/>
    </div>
  );
}
